import React from 'react';
import { usePermission, useAnyPermission } from '../hooks/usePermission';

interface RequirePermissionProps {
  permission?: string;
  /** Allow access if the user has any of these permissions. Use either `permission` OR `anyOf`. */
  anyOf?: string[];
  children: React.ReactNode;
  /** Optional custom fallback content when the user lacks the permission. */
  fallback?: React.ReactNode;
}

/**
 * Renders children only when the current user has the given permission slug.
 * Otherwise displays a "Brak uprawnień do tej sekcji" message (or custom fallback).
 *
 * Drop-in replacement for the legacy <RequireRole> guard.
 */
export const RequirePermission: React.FC<RequirePermissionProps> = ({
  permission,
  anyOf,
  children,
  fallback,
}) => {
  const allowedSingle = usePermission(permission ?? '__none__');
  const allowedAny = useAnyPermission(anyOf ?? []);
  const allowed = anyOf ? allowedAny : allowedSingle;

  if (!allowed) {
    if (fallback !== undefined) return <>{fallback}</>;
    return (
      <div className="text-center py-8 text-muted-foreground">
        Brak uprawnień do tej sekcji
      </div>
    );
  }

  return <>{children}</>;
};
